<div *ngIf="!isHidden" class="pt-5">
  <lpcr-app-card card="plain">
    <div class="notice-board-item-container w-full flex flex-col px-2 lg:px-12">

      <div class="my-2 text-center text-primary font-bold text-3xl">
        {{ title }}
      </div>
      <div *ngIf="base64Image" alt="" class="mt-3 flex justify-center">
        <img [src]="base64Image" />
      </div>
      <p class="mt-3">{{ contentText }}</p>
      <div *ngIf="moreInformationURL" class="flex justify-center w-full mt-5">
        <button type="button" class="lpcr-button lpcr-button-primary" variant="primary"
          (click)="onMoreInformationClick()">
          En savoir plus
        </button>
      </div>

    </div>
  </lpcr-app-card>
</div>